module.exports = __webpack_public_path__ + "img/d201002-1.c3ab466c.jpg";